import { setStroage } from 'utils'

// 接口源地址
const apiUrl = process.env.REACT_APP_SERVER

// 登陆请求
export const loginApi = params => {
    return fetch(`${apiUrl}/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    }).then(async response => {
        if (response.ok) {
            const data = await response.json()
            switch (data.code) {
                case 200:
                    setStroage('token', data.data.token) // 存储 token
                    if (params.remember) {
                        setStroage('account', JSON.stringify(params)) // 记住账号密码
                    }
                    return data
                case 500:
                    return Promise.reject(data.msg)
                default:
            }
        } else {
            return Promise.reject('网络错误或链接被拒绝')
        }
    })
}
